import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries/index.js';

function genSha256(bytes: BufferSource): Promise<Uint8Array> {
  const hash = crypto.subtle.digest({ name: 'SHA-256' }, bytes);
  return new Promise((resolve, reject) => {
    Promise.resolve(hash)
      .then(function (result) {
        resolve(new Uint8Array(result));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

async function hash(query?: string) {
  const buf = new TextEncoder().encode(query);
  const out = await genSha256(buf);

  let hash = '';
  for (let i = 0, l = out.length; i < l; i++) {
    const hex = out[i].toString(16);
    hash += '00'.slice(0, Math.max(0, 2 - hex.length)) + hex;
  }

  return hash;
}

export const persistedLink = () =>
  createPersistedQueryLink({
    sha256: hash,
    useGETForHashedQueries: false
  });
